module.exports = __webpack_public_path__ + "a4816c036afbe4dd981282562a05cf02.svg";